'use client';

// 访问轮次只存在当前文档内，不写优惠缓存；离开时 MiniCart 仍读取原有选择。
// 新文档由 Navigation Timing 区分普通进入与刷新，同页登录门控重挂载复用本轮结果。
let cartEntryConsumed = false;
let enteredFromAnotherRoute = false;

export function recordCartOfferRoute(pathname: string): void {
  if (!pathname || pathname.replace(/\/$/, '') === '/cart') return;
  cartEntryConsumed = false;
  enteredFromAnotherRoute = true;
}

/** 仅在购物车首次恢复优惠时消费，不能把 StrictMode 或身份重挂载当成重新入场。 */
export function consumeCartOfferReentry(): boolean {
  if (cartEntryConsumed) return false;
  cartEntryConsumed = true;
  if (enteredFromAnotherRoute) {
    enteredFromAnotherRoute = false;
    return true;
  }

  try {
    const navigation = performance.getEntriesByType('navigation')[0] as
      | PerformanceNavigationTiming
      | undefined;
    // reload 保留手动券；当前文档之后从其他路由返回，仍由上面的路径标记恢复自动。
    return navigation?.type === 'navigate' || navigation?.type === 'back_forward';
  } catch {
    // 浏览器不提供 Navigation Timing 时保守保留；同文档路由返回仍可正常识别。
    return false;
  }
}
